import router from '@/router';
import { auth } from '@/security/auth';
import { btoa } from '@/utils';

const whiteList = ['/login', '/401', '/403', '/404'];

router.beforeEach((to, from, next) => {
  // Si llega aquí es que la URI existe en la aplicación
  if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else if (auth.userIsAuthenticated()) {
    let pathRoles = to.meta && to.meta.roles; // pathRoles puede ser null
    if (auth.userAuthenticatedHasRole(pathRoles)) {
      next();
    } else {
      next('/403');
    }
  } else {
    let param =
      to.query['empresa'] && to.query['NRC']
        ? { empresa: to.query['empresa'], NRC: to.query['NRC'] }
        : {};
    let uriRedirect = {
      path: to.path,
      params: param
    };
    next({
      name: 'login',
      params: { redirect: btoa(JSON.stringify(uriRedirect)) }
    });
  }
});
